import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/api/EmailDomain";

export const getEmailDomain = async () => {
  return await axios.get(api_base_url)
};

export const addEmailDomain = async (newEmailDomain) => {
  const { data } = await axios.post(api_base_url, {
    ...newEmailDomain,
  });
  return data;
};

export const deleteEmailDomain = async (ids) => {
   const { data } = await axios.delete(api_base_url, {
    data: ids,
  });
  return data;
};

export const updateDomainName = async (editEmailDomain) => {
  const { data } = await axios.put(api_base_url, editEmailDomain);
  return data;
};
